<script setup>
    import AppCompanySwitchOverlay from "~/components/app/AppCompanySwitchOverlay.vue"
</script>

<template>
    <v-app>
        <ReloadPrompt />
        <InstallPrompt />
        <AppCompanySwitchOverlay />
        <Router-view />
    </v-app>
</template>
